import React, { useState } from "react";
import FormContent from "components/organisms/formContent/index.jsx";
import Button from "components/atoms/button/index.jsx";
import FormFieldset from "components/molecules/formFieldset/index.jsx";
import FormCol from "components/molecules/formCol/index.jsx";
import FormTextField from "components/molecules/formTextField/index.jsx";
import FormTextArea from "components/molecules/formTextArea/index.jsx";
import FormSelect from "components/molecules/formSelect/index.jsx";
import FormActions from "components/molecules/formActions/index.jsx";

const sampleYear = new Date().getFullYear() - 3;

const SellForm = ({ handleSubmit, brands, models, engines, transmissions, bodies }) => {
  const [pristine, setPristine] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({
    name: "",
    email: "",
    lastname: "",
    cellphone: "",
    brand: "",
    version: "",
    model: "",
    engine: "",
    transmission: "",
    body: "",
    license_plate: "",
    kms: "",
    year: "",
    color: "",
  });

  const handleChange = (e) => {
    setData({ ...data, [e.currentTarget.name]: e.currentTarget.value });
    setPristine(false);
  };

  const brand_id = brands.find((brand) => brand.name === data.brand)?.brand_id;

  const filteredModels = models.filter(
    (model) => model.id_brand === brand_id
  );

  const empty =
    !data.name ||
    !data.lastname ||
    !data.cellphone ||
    !data.year ||
    !data.brand ||
    !data.engine ||
    !data.kms ||
    !data.license_plate ||
    !data.color;

  return (
    <FormContent>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          setSubmitting(true);
          handleSubmit(data);
        }}
      >
        <FormFieldset>
          <h3>Tus datos </h3>

          <FormCol first="true">
            <FormTextField
              name="name"
              type="text"
              label="Nombre"
              onChange={handleChange}
              value={data.name}
              tabIndex="1"
              required
            />

            <FormTextField
              name="email"
              type="email"
              label="Correo electrónico"
              placeholder="email@gmail.com"
              onChange={handleChange}
              value={data.email}
              tabIndex="3"
              required
            />
          </FormCol>

          <FormCol last="true">
            <FormTextField
              name="lastname"
              type="text"
              label="Apellido"
              onChange={handleChange}
              value={data.lastname}
              tabIndex="2"
              required
            />

            <FormTextField
              name="cellphone"
              type="text"
              label="Celular"
              onChange={handleChange}
              value={data.cellphone}
              tabIndex="4"
              required
            />
          </FormCol>

          <h3>Tu vehículo</h3>

          <FormSelect
            name="brand"
            appendEmptyOption
            label="Marca"
            options={brands}
            onChange={handleChange}
            value={data.brand}
            tabIndex="5"
            required
          />

          <FormSelect
            name="model"
            appendEmptyOption
            label="Modelo"
            options={filteredModels}
            onChange={handleChange}
            value={data.model}
            tabIndex="6"
          />

          <FormTextField
            name="version"
            type="text"
            label="Versión del vehículo"
            placeholder="LTZ, LT, Trendline, Highline, SR, Exclusive"
            onChange={handleChange}
            value={data.version}
            tabIndex="7"
          />

        <FormSelect
            name="engine"
            appendEmptyOption
            label="Motor"
            options={engines}
            onChange={handleChange}
            value={data.engine}
            tabIndex="8"
          />

          <FormSelect
            name="transmission"
            appendEmptyOption
            label="Transmisión"
            options={transmissions}
            onChange={handleChange}
            value={data.transmission}
            tabIndex="9"
          />

          <FormSelect
            name="body"
            appendEmptyOption
            label="Tipo de carrocería"
            options={bodies}
            onChange={handleChange}
            value={data.transmission}
            tabIndex="10"
          />

          <h3>Detalles generales</h3>

          <FormCol first="true">
            <FormTextField
              name="license_plate"
              label="Número de patente/dominio"
              type="text"
              placeholder="AB000AA o ABC123"
              onChange={handleChange}
              value={data.license_plate}
              tabIndex="11"
              required
            />
          </FormCol>
          <FormCol last="true">
            <FormTextField
              name="kms"
              label="Kilometraje actual"
              type="text"
              placeholder="Kilometraje actual aproximado"
              onChange={handleChange}
              value={data.kms}
              tabIndex="12"
              required
            />
          </FormCol>

          <FormCol first="true">
            <FormTextField
              name="year"
              label="Año de patentamiento"
              type="text"
              placeholder={sampleYear}
              onChange={handleChange}
              value={data.year}
              tabIndex="13"
              required
            />
          </FormCol>
          <FormCol last="true">
            <FormTextField
              name="color"
              label="Color del vehículo"
              type="text"
              placeholder="Rojo, azul, amarillo"
              onChange={handleChange}
              value={data.color}
              tabIndex="14"
              required
            />
          </FormCol>
          <FormCol last="true" />

          <FormTextField
            name="image_0"
            id="image_0"
            label="Fotos del vehículo"
            type="file"
            onChange={handleChange}
          />
          <FormTextField
            name="image_1"
            id="image_1"
            type="file"
            onChange={handleChange}
          />
          <FormTextField
            name="image_2"
            id="image_1"
            type="file"
            onChange={handleChange}
          />

          <FormTextArea
            name="comments"
            label="Estado del vehículo"
            onChange={handleChange}
            value={data.comments}
            tabIndex="15"
          />
        </FormFieldset>

        <FormActions>
          <Button
            disabled={pristine || submitting || empty}
            buttonText="Hacer pedido"
            type="submit"
          />
        </FormActions>
      </form>
    </FormContent>
  );
};

export default SellForm;
